import {
  ClientPrintJob,
  DefaultPrinter,
  FileSourceType,
  JSPrintManager,
  PrintFilePDF,
  Sizing,
  WSStatus,
} from 'jsprintmanager';

const startJSPMWithTimeout = () =>
  new Promise((resolve, reject) => {
    const timeout = setTimeout(() => {
      if (JSPrintManager.websocket_status !== WSStatus.Open) reject(new Error('Timeout'));
    }, 1500);
    JSPrintManager.start()
      .then(() => {
        if (JSPrintManager.websocket_status === WSStatus.Open) {
          clearTimeout(timeout);
          resolve();
        } else {
          clearTimeout(timeout);
          reject(new Error('Handshake failed'));
        }
      })
      .catch((err) => {
        clearTimeout(timeout);
        reject(err);
      });
  });

// Sends a label PDF straight to the operator's default printer via
// JSPrintManager — same client-print-server contract as handlePrintLabel in
// common/hooks/usePrintLabelContext.js (the app's only other print path), so
// JSPM must be running locally with a default printer configured. Every
// failure notifies the operator with the specific reason before rejecting, so
// callers don't need to notify again — they only need to react to the status.
const printLabelViaJspm = async (labelUrl, notify) => {
  if (JSPrintManager.websocket_status !== WSStatus.Open) {
    try {
      JSPrintManager.auto_reconnect = false;
      await startJSPMWithTimeout();
    } catch {
      notify?.('Printer client not installed or not running — could not print the label.', 'error');
      throw new Error('jspm-not-connected');
    }
  }

  try {
    const printers = await JSPrintManager.getPrinters();
    if (!printers || printers.length === 0) {
      notify?.('Default printer not configured — could not print the label.', 'error');
      throw new Error('no-default-printer');
    }

    const cpj = new ClientPrintJob();
    cpj.clientPrinter = new DefaultPrinter();

    const file = new PrintFilePDF(labelUrl, FileSourceType.ExternalURL, `${Date.now()}.pdf`, 1);
    file.pageSizing = Sizing.None;
    file.usePaperSize = true;
    file.printCentering = true;

    cpj.files.push(file);
    cpj.sendToClient();
  } catch (err) {
    if (err?.message === 'no-default-printer') throw err;
    notify?.('JSPM error — could not send the label to the printer.', 'error');
    throw err;
  }
};

export default printLabelViaJspm;
